import { c as _c } from "react/compiler-runtime";
import { FormInput, Modal, PrimaryButton, copyTextToClipboard } from '@systemeio/ui';
import React, { useEffect, useState } from 'react';
import FormTextarea from 'shared/components/form-textarea';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { FunnelStepId } from '../../../types/funnel-step-interface';
import { getScriptLinkHtmlCode } from '../../../utils/remote-form-utils';
interface CreateRemotePopupLinkModalProps {
  opened: boolean;
  onClose: () => void;
  domainName: string;
  pageHash: string;
  funnelStepId: FunnelStepId;
}
const CreateRemotePopupLinkModal = t0 => {
  const $ = _c(44);
  const {
    opened,
    onClose,
    domainName,
    pageHash,
    funnelStepId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.funnel.configuration.remote.anchor_name_placeholder");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const defaultAnchorName = t1;
  const [tempAnchorName, setTempAnchorName] = useState(defaultAnchorName);
  let t2;
  if ($[2] !== domainName || $[3] !== funnelStepId || $[4] !== pageHash || $[5] !== tempAnchorName) {
    t2 = getScriptLinkHtmlCode(domainName, pageHash, funnelStepId, tempAnchorName);
    $[2] = domainName;
    $[3] = funnelStepId;
    $[4] = pageHash;
    $[5] = tempAnchorName;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const [tempLink, setTempLink] = useState(t2);
  let t3;
  if ($[7] !== domainName || $[8] !== funnelStepId || $[9] !== pageHash || $[10] !== tempAnchorName) {
    t3 = () => {
      setTempLink(getScriptLinkHtmlCode(domainName, pageHash, funnelStepId, tempAnchorName));
    };
    $[7] = domainName;
    $[8] = funnelStepId;
    $[9] = pageHash;
    $[10] = tempAnchorName;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== tempAnchorName) {
    t4 = [tempAnchorName];
    $[12] = tempAnchorName;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  useEffect(t3, t4);
  let t5;
  if ($[14] !== defaultAnchorName || $[15] !== onClose) {
    t5 = () => {
      onClose();
      setTempAnchorName(defaultAnchorName);
    };
    $[14] = defaultAnchorName;
    $[15] = onClose;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t) {
    t6 = t("dashboard.funnel.configuration.remote.modal_link_header");
    $[17] = t;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t) {
    t7 = t("dashboard.funnel.configuration.remote.anchor");
    $[19] = t;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = e => setTempAnchorName(e.target.value);
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t7 || $[23] !== tempAnchorName) {
    t9 = <FormInput label={t7} value={tempAnchorName} onChange={t8} />;
    $[22] = t7;
    $[23] = tempAnchorName;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== tempLink) {
    t10 = <div className="flex flex-col justify-center gap-3"><FormTextarea value={tempLink} disabled={true} /></div>;
    $[25] = tempLink;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t || $[28] !== tempLink) {
    t11 = async e_0 => {
      e_0.preventDefault();
      await copyTextToClipboard(tempLink, t("global.copy_clipboard"));
    };
    $[27] = t;
    $[28] = tempLink;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t) {
    t12 = t("global.copy_to_clipboard_caption");
    $[30] = t;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t11 || $[33] !== t12) {
    t13 = <div className="flex justify-center gap-4"><PrimaryButton onClick={t11}>{t12}</PrimaryButton></div>;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t10 || $[36] !== t13 || $[37] !== t9) {
    t14 = <form className="flex flex-col gap-6 lg:gap-10">{t9}{t10}{t13}</form>;
    $[35] = t10;
    $[36] = t13;
    $[37] = t9;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== opened || $[40] !== t14 || $[41] !== t5 || $[42] !== t6) {
    t15 = <Modal opened={opened} onClose={t5} title={t6}>{t14}</Modal>;
    $[39] = opened;
    $[40] = t14;
    $[41] = t5;
    $[42] = t6;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  return t15;
};
export default CreateRemotePopupLinkModal;